import getVal from './utils/getVal';

export default async function getXml(url, query) {
    const endpoint = `${url}webcharts.com/child.xml`;
    const params = `?wcd=${getVal(query.wcd)}&wct=${getVal(query.wct)}&wcs=${getVal(query.wcs)}`;
    const response = await fetch(`${endpoint}${params}`, {
        method: 'GET',
    }).then((res) => res.blob());
    return response;
}

/* EXAMPLE:
const anchor = document.createElement('a');
document.body.appendChild(anchor);
const blob = await getXml('https://dev-calculator.morethanheight.com/uk/', {
    wcd: 'M403971800015000440561400003200',
});
const objectUrl = URL.createObjectURL(blob);
anchor.href = objectUrl;
const fileName = 'GrowthChart.xml';
anchor.download = fileName;
anchor.click();
URL.revokeObjectURL(objectUrl);
*/
